<template>
  <div class="crud_form_wrapper">
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.view_reservation") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #233076">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>

    <div class="single_step_form_content_wrapper">
      <form>
        <div class="row">
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.patient')"
            v-model.trim="data.patient"
            disabled
          />
          <base-select-input
            col="6"
            :optionsList="branches"
            :placeholder="$t('PLACEHOLDERS.branch')"
            v-model="data.branch"
            disabled
          />
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.age')"
            v-model.trim="data.age"
            disabled
          />
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.order_price')"
            v-model.trim="data.cost"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.reservation_type')"
            v-model.trim="data.reservation_type"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.date')"
            v-model.trim="data.date"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.time')"
            v-model.trim="data.time"
            disabled
          />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShowReservation",

  data() {
    return {
      branches: [],
      data: {
        patient: null,
        branchId: null,
        branch: null,
        age: null,
        cost: null,
        reservation_type: null,
        date: null,
        time: null,
      },
    };
  },

  methods: {
    async getData() {
      try {
        const res = await this.$axios({
          method: "GET",
          url: `reservations/${this.$route.params.id}`,
        });
        const item = res.data?.data?.Reservation || {};
        this.data.patient = item.patient?.name || item.patient_id;
        this.data.branchId = item.branch?.id || item.branch_id || null;
        this.data.branch = item.branch
          ? {
              id: item.branch.id,
              name: item.branch.name,
            }
          : null;
        this.data.age = item.age;
        this.data.cost = item.cost ?? item.total_cost ?? null;
        this.data.reservation_type =
          item.reservation_type === "consultation"
            ? "استشارة"
            : item.reservation_type === "checkup"
            ? "كشف"
            : item.reservation_type;
        this.data.date = item.date;
        this.data.time = item.time;
      } catch (error) {
        this.$message.error(
          error?.response?.data?.message || "Failed to load reservation details"
        );
      }
    },

    async getBranches() {
      try {
        const res = await this.$axios({
          method: "GET",
          url: "branches",
          params: {
            page: 0,
            limit: 0,
          },
        });
        const payload = res.data?.data || {};
        this.branches = (payload.data || []).map((item) => ({
          id: item.id,
          name: item.name,
        }));

        if (this.data.branchId) {
          this.data.branch =
            this.branches.find((branch) => branch.id == this.data.branchId) ||
            this.data.branch;
        }
      } catch (error) {
        this.$message.error(
          error?.response?.data?.message || "Failed to load branches"
        );
      }
    },
  },

  async created() {
    await this.getData();
    await this.getBranches();
  },
};
</script>
